import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchStoryboard, saveStoryboardSettings } from "./ducks/actions";
import Storyboard from "./storyboard";

const StoryboardContainer = (props) => {
    const filmId = props.match.params.filmId;
    const { fetchStoryboard, scenes, shotsByScene, loading, saveStoryboardSettings, settings } = props;

    useEffect(() => {
        fetchStoryboard(filmId);
    }, [filmId, fetchStoryboard]);

    return (
        <Storyboard
            scenes={scenes}
            shotsByScene={shotsByScene}
            loadingShots={loading}
            filmId={filmId}
            settings={settings}
            saveSettings={(s) => saveStoryboardSettings(filmId, s)}
        />
    );
};

function mapStateToProps(state) {
    return {
        scenes: state.scenesState.storyboardState.scenes,
        loading: state.scenesState.storyboardState.loading,
        settings: state.scenesState.storyboardState.settings
    };
}

export default connect(mapStateToProps, { fetchStoryboard, saveStoryboardSettings })(StoryboardContainer);
